import styled from 'styled-components'
import { theme } from 'theme'

interface CardContainerProps {
    padding: string
    showBorder: boolean
}

export const CardContainer = styled.div<CardContainerProps>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: fit-content;
    width: 100%;
    box-sizing: border-box;
    background-color: ${theme.newColors.neutral50};
    padding: ${({ padding }) => padding};
    border: ${({ showBorder }) => (showBorder ? '1px solid ' + theme.newColors.neutral200 : 'none')};
    gap: ${theme.newSpacing.m};
    align-self: stretch;
    .title-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        align-items: flex-start;
        align-self: stretch;
    }
    .title-description-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        gap: ${theme.newSpacing.m};
    }
    .registration-table {
        width: 100%;
        height: 112px;
    }
    .registration-slot-left {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${theme.newSpacing.xxxxs};
    }
    .submission-table {
        width: 100%;
        height: auto;
    }
`
export const InfoContainer = styled.div`
    width: 200px;
    box-sizing: border-box;
`
